export enum AlertType {
  INFO = 'info',
  WARNING = 'warning',
  WARNING_LIGHT = 'warning-light',
}
